import { EDITOR_VIEW_NAME } from "../core/constants";
import { getViewData } from "../core/views";

export function getEditorContentFromTab(name) {
  const state = getViewData(EDITOR_VIEW_NAME);
  const tab = state.data.editorTabs?.find((item) => item.name === name);
  if (!tab) {
    const projectTab = state.data.projectContent.tabs.find((item) => item.name === name);
    if (!projectTab) return "";
    return projectTab.code;
  }

  return tab.code;
}